import { type GetStaticProps } from 'next';
import { BlogPost } from '../../components/blog/post/Post';
import {
  getAllBlogPostIds,
  getBlogPostData,
  PostData,
} from '../../components/blog/utils';

interface Props {
  postData: PostData;
}

export default function BlogSlugPage({ postData }: Props) {
  return <BlogPost postData={postData} />;
}

export async function getStaticPaths() {
  const paths = getAllBlogPostIds();
  return {
    paths,
    fallback: false,
  };
}

export const getStaticProps: GetStaticProps<Props, { slug: string }> = async ({ params, }) => {
  if (!params?.slug) throw new Error('Blog post slug is `undefined`');

  return {
    props: {
      postData: await getBlogPostData(params.slug),
    },
  };
};